/**
 * Zod schemas for EDU Component Catalog validated types.
 *
 * This is the single source of truth — TypeScript types in types.ts are
 * derived from these schemas via z.infer<>.  The validate-edu-metadata
 * script imports the schemas directly for runtime validation.
 */
import { z } from 'zod';

export const COMPONENT_CATEGORIES = [
  'layout',
  'navigation',
  'content',
  'form',
  'data',
] as const;

export const COMPONENT_ID_PATTERN = /^hen\.[a-z][a-zA-Z]*$/;

export const TITLE_PREFIXES = ['Atomics', 'Composites', 'Layout'] as const;

export const CatalogSlotDefinitionSchema = z.object({
  description: z.string().trim().min(1),
  allowedComponents: z.array(z.string()).optional(),
});

export const CatalogEventDefinitionSchema = z.object({
  description: z.string().trim().min(1),
  eventName: z.string().trim().min(1),
  payload: z.record(z.string()).optional(),
});

export const EduStoryParametersSchema = z.object({
  id: z.string().regex(COMPONENT_ID_PATTERN),
  category: z.enum(COMPONENT_CATEGORIES),
  slots: z.record(CatalogSlotDefinitionSchema).optional(),
  events: z.record(CatalogEventDefinitionSchema).optional(),
});

export type ComponentCategory = (typeof COMPONENT_CATEGORIES)[number];
export type CatalogSlotDefinition = z.infer<typeof CatalogSlotDefinitionSchema>;
export type CatalogEventDefinition = z.infer<
  typeof CatalogEventDefinitionSchema
>;
export type EduStoryParameters = z.infer<typeof EduStoryParametersSchema>;
